import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from 'helpers/api_helper';  // your api helper

function* fetchExtraPaymentPayrollSaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload?.unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_EXTRA_PAYMENT_PAYROLL, formData);
    
    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch extra payment payroll!');
    }

    yield put({ type: types.FETCH_EXTRA_PAYMENT_PAYROLL_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_EXTRA_PAYMENT_PAYROLL_FAILURE, payload: error });
  }
}

function* savePayrollSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_PAYROLL, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save payroll!');
    }

    yield put({ type: types.SAVE_PAYROLL_SUCCESS, payload: response.data });
    Swal.fire('Success', response?.message || 'Payroll saved successfully!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_PAYROLL_FAILURE, payload: error });
  }
}

function* changePayrollStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_PAYROLL_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change payroll status!');
    }

    yield put({ type: types.CHANGE_PAYROLL_STATUS_SUCCESS, payload: response.data });
    Swal.fire('Success', response?.message || 'Payroll status changed successfully!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.CHANGE_PAYROLL_STATUS_FAILURE, payload: error });
  }
}

export default function* payrollSaga() {
  yield takeLatest(types.FETCH_EXTRA_PAYMENT_PAYROLL_REQUEST, fetchExtraPaymentPayrollSaga);
  yield takeLatest(types.SAVE_PAYROLL_REQUEST, savePayrollSaga);
  yield takeLatest(types.CHANGE_PAYROLL_STATUS_REQUEST, changePayrollStatusSaga);
}
